<template>
  <div v-if="visible" class="recovery-banner">
    <i class="ri-live-line"></i>
    <span>{{ $t('live.recovery.banner') }}</span>
    <button class="recover-btn" @click="recover">{{ $t('live.recovery.resume') }}</button>
    <button class="dismiss-btn" @click="dismissed = true" aria-label="dismiss"><i class="ri-close-line"></i></button>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useLiveStore } from '../store/liveStore'
import { LIVE_PHASES } from '../constants/liveConfig'
import { hasValidAccessToken } from '@/shared/utils/authSession.util'

export default defineComponent({
  name: 'LiveRecoveryBanner',
  setup() {
    const liveStore = useLiveStore()
    const router = useRouter()
    const dismissed = ref(false)

    const visible = computed(() =>
      !dismissed.value &&
      liveStore.canResumeHostLive &&
      liveStore.phase === LIVE_PHASES.IDLE
    )

    onMounted(() => {
      if (hasValidAccessToken()) {
        liveStore.checkForActiveLive()
      }
    })

    async function recover() {
      await liveStore.recoverLive()
      if (liveStore.phase === LIVE_PHASES.ENDED) {
        router.push({ name: 'live.host.end.screen' })
        return
      }
      if (liveStore.streamStatus === 'WAITING') {
        await liveStore.goLive()
      }
      const nav = liveStore.pendingNavigation
      liveStore.clearPendingNavigation()
      if (nav === 'hostEnd') router.push({ name: 'live.host.end.screen' })
      else if (nav === 'hostLive') router.push({ name: 'live.host.screen' })
    }

    return { visible, recover, dismissed, liveStore }
  },
})
</script>

<style scoped>
.recovery-banner {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9000;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 16px;
  background: #1a1a2e;
  border: 1px solid rgba(139,92,246,0.5);
  color: #fff;
  box-shadow: 0 8px 32px rgba(0,0,0,0.35);
  max-width: min(480px, 92vw);
}
.recovery-banner i { color: #ef4444; font-size: 20px; }
.recover-btn { padding: 6px 14px; border-radius: 14px; border: none; background: #8b5cf6; color: #fff; cursor: pointer; font-weight: 600; font-size: 13px; }
.dismiss-btn { background: transparent; border: none; color: rgba(255,255,255,0.6); cursor: pointer; font-size: 18px; }
</style>
